<template>
    <div class="flex items-center flex-wrap">
        <label class="py-2 px-4 first:ml-0 ml-1 cursor-pointer" :class="getActiveClass(option)" v-for="option in options" :key="getValue(option)">
            <input type="radio" :name="name" :value="getValue(option)" :checked="isActive(option)" @change="inputHandler" class="hidden"> {{getLabel(option)}}
        </label>
    </div>
</template>

<script>
    export default {
        name: "EvRadioGroup",
        emits: ['input', 'update:modelValue', 'update:value'],
        props: {
            name: {required:true},
            value: { default: undefined },
            modelValue: { default: undefined },
            options: {
                required:true,
                default(){ return [] }
            },
            valueKey: {
                default : 'value'
            },
            labelKey: {
                default : 'label'
            }
        },
        methods: {
            emitValue(value) {
                this.$emit('update:modelValue', value);
                this.$emit('update:value', value);
                this.$emit('input', value);
            },
            getValue(option) {
                if (typeof option === 'object') {
                    return option[this.valueKey];
                }
                return option;
            },
            getActiveClass(option){
                if( this.isActive(option) ){
                    return ['bg-main-300' ,'text-white']
                }else{
                    return ['bg-white','border', 'text-black','border-main-200']
                }
            },
            isActive(option) {
                if (typeof option === 'object') {
                    return option[this.valueKey] == this.resolvedValue;
                }
                return option == this.resolvedValue;
            },
            getLabel(option) {
                if (typeof option === 'object') {
                    return option[this.labelKey];
                }
                return option;
            },
            inputHandler(e) {

                this.emitValue(e.target.value);
            }
        },
        computed: {
            resolvedValue() {
                return typeof this.modelValue !== 'undefined' ? this.modelValue : this.value;
            }
        }
    }
</script>

<style scoped>

</style>
